export class EnvironmentConfigurations {
    PLANT_A_TREE_SUBSCRIBE_ADDONS: any;
    EINITIATIVE_SOCIAL_MEDIA_POST_CONTENT: any;
    EINITIATIVE_INTERVAL : any;
    EINITIATIVE_PLANT_A_TREE_EVENT_ENABLE : any;
    REDIRECTION_URL_PAGE_NOT_FOUND: any;
    EINITIATIVE_PLANT_A_TREE_EVENT_SHARE_OPTION_ENABLE:any;
}